module.exports = __webpack_public_path__ + "static/media/jedi.5a54b13c.svg";